import { TextAreaRoot } from './TextAreaRoot'

export const TextArea = {
  Root: TextAreaRoot,
}
